import { useTranslations } from 'next-intl';

import { TicketModel, AcceptTicketStatus } from '@/hooks/query';
import { addCommasWithFix } from '@/utils/odds-utils';
import { useBetslipContext } from '@/features/betslip/contexts/betslip-context';
import { ConfirmBetSimpleChoice } from '@/features/betslip/confirm-bet/components/confirm-bet-simple-choice';
import { ConfirmBetTicketStatus } from '@/features/betslip/confirm-bet/components/confirm-bet-ticket-status';

export const BookingConfirmHeader = ({
	status,
	ticket
}: {
	status: AcceptTicketStatus,
	ticket: TicketModel;
}) => {
	const t = useTranslations('General');
	const { currencyName, currencySymbol } = useBetslipContext();
	const formattedStake = addCommasWithFix(ticket.stake);
	const ticketStake = `${currencySymbol}${formattedStake}`;

	return (
		<div className="confirm-bet-header">
			<div className="confirm-bet-header__status">
				<ConfirmBetTicketStatus 
					status={status} 
					isHeader={true} 
				/>
			</div>
			<div className="confirm-bet-header__info">
				<div className="confirm-bet-header__title">
					{`${currencyName} ${ticketStake} ${t('lbl_SingleBet')}`}
				</div>
				<div className="confirm-bet-header__content">
					<ConfirmBetSimpleChoice tickets={[ticket]} />
				</div>
			</div>
		</div>
	);
};